import * as React from 'react'

type ErrorBoundaryViewContract = Required<ErrorBoundaryState>

export interface ErrorBoundaryState {
  readonly error: Error
  readonly errorInfo: React.ErrorInfo
}

type ErrorBoundaryProps<ViewProps extends ErrorBoundaryViewContract> = Omit<
  ViewProps,
  keyof ErrorBoundaryViewContract
>

export const createErrorBoundary = <
  ViewProps extends ErrorBoundaryViewContract
>(
  View: React.ComponentType<ViewProps>
) =>
  class ErrorBoundary extends React.Component<
    ErrorBoundaryProps<ViewProps>,
    ErrorBoundaryState
  > {
    constructor(props: ErrorBoundaryProps<ViewProps>) {
      super(props)

      this.state = {
        error: undefined,
        errorInfo: undefined
      }
    }

    public override componentDidCatch(
      error: Error,
      errorInfo: React.ErrorInfo
    ): void {
      this.setState({error, errorInfo})
    }

    public override render(): React.ReactNode {
      const Comp = View as any
      return <Comp {...this.props} {...this.state} />
    }
  }
